    <template>
    <div class="home">

        <div class="creppy-white-blass-wait">
            <h5 style="padding-top: 20px" class="display-title-strong middle-wave text-white">NameTag Richtlinien</h5>

            <br class="no-move"/>

        </div>

        <div class="main-title">

            <br class="no-move"/>


            <br class="no-move"/>

            <p class="text-normal-title">Folgende Regeln müssen eingehalten werden, wenn ein NameTag genutzt wird:</p>
            <br/>
            <p class="smaller-end-text container">
                (1) Nametags dürfen keinerlei extremistische, gewalttätige oder sonstige kriminelle Inhalte enthalten.
                Dazu zählt auch das Verbreiten einer gewalttätigen oder rassistischen Organisation oder Ähnliches.
                <br class="no-move"/>
                <br class="no-move"/>
                (2) Die Verbreitung von Websiten o.ä. die pornografische, extremistische, gewalttätige, aber auch
                Inhalte die für Minderjährige nicht geeignet sind ist untersagt.
                <br class="no-move"/>
                <br class="no-move"/>
                (3) Ein NameTag darf keine provokante, beleidigende oder diskriminierende Inhalte enthalten!
                <br class="no-move"/>
                <br class="no-move"/>
                (4) Die Fälschung eines LabyHelp-Ranges ist verboten.
                <br class="no-move"/>
                <br class="no-move"/>
                (5) Keine Zeichenketten oder änliche Spam Inhalte.
            </p>
            <p class="footnote-text text-white-gray-color">Letzte Änderung erfolgte am 25.02.2021.</p>

            <br class="no-move"/>

            <hr class="container"/>

            <div class="container">

                <h1 class="headers-text text-dark"><strong>Zusatz</strong></h1>
                <p class="smaller-end-text text-dark">
                    Alle Rechte vorbehalten!
                    Die Anweisungen und Warnungen eines jeden Mitglieds des LabyHelp Teams müssen ernst genommen und befolgt werden.
                    Wenn eine Sperrung oder eine Löschung aus Sicht eines Teammitglieds begründet ist, bleibt er gültig! NameTag Bans werden nur bei absoluten Missverständnissen aufgehoben.
                    Teammitglieder sind nicht verpflichtet sich für einen Ban zu rechtfertigen. Jeglicher Regelbruch wird mit einer NameTag sperre bestraft!</p>

            </div>

            <br class="no-move"/>

            <div class="" style="alignment: bottom">

                <div class="" style="alignment: bottom">
                    <p class="smaller-end-text">© {{ today.getFullYear() }}
                        <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a> -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/support">Support</a>
                        -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/apply">Apply</a>
                        -
                        <a style="color: #6868b3"
                           href="https://labyhelp.de/creator">Creator</a>
                        -
                        <a style="color: #6868b3"
                           href="ts3server://labyhelp.de">TeamSpeak</a>
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "Team",
    data() {
        return {
            today: new Date()
        }
    },
}
</script>

<style scoped>

</style>